import React from 'react';
import { Trash2 } from 'lucide-react';
import { Button } from '../../ui/Button';

interface DeleteShareConfirmProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
}

export const DeleteShareConfirm: React.FC<DeleteShareConfirmProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isDeleting
}) => {
  if (!isOpen) return null;

  return (
    <>
      <div onClick={onClose} className="fixed inset-0 bg-black/50 z-[300]" aria-hidden="true" />
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="delete-confirm-title"
        className="fixed bottom-0 left-0 right-0 bg-white rounded-t-[20px] z-[301] p-5 pb-[calc(32px+env(safe-area-inset-bottom,0px))] animate-slideUp"
      >
        <div className="text-center mb-5">
          <div className="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-4">
            <Trash2 className="w-6 h-6 text-red-600" />
          </div>
          <h3 id="delete-confirm-title" className="text-[17px] font-semibold text-neutral-900 mb-2">
            Delete share link?
          </h3>
          <p className="text-sm text-neutral-500">
            This will permanently remove the share link. Anyone with the link will no longer be able to access this dataset.
          </p>
        </div>
        <div className="flex gap-3">
          <Button onClick={onClose} variant="secondary" fullWidth>Cancel</Button>
          <Button onClick={onConfirm} disabled={isDeleting} loading={isDeleting} variant="danger" fullWidth>
            {isDeleting ? 'Deleting...' : 'Delete'}
          </Button>
        </div>
      </div>
    </>
  );
};
